import '@/styles/globals.css'
import type { AppProps } from 'next/app'
import Header from '@/components/Header'
import Footer from '@/components/Footer'
import dynamic from 'next/dynamic'
import SubmitForm from '@/components/SubmitForm'
import Head from 'next/head'

const ContactActions = dynamic(() => import('@/components/ContactActions'), {
  ssr: false,
})

export default function App({ Component, pageProps }: AppProps) {
  return (
    <>
            <Head>
              <link rel="icon" href="/icons/icon-48x48.png" type="image/png" />
              <link rel="shortcut icon" href="/icons/icon-48x48.png" type="image/png" />
              <link rel="manifest" href="/manifest.json" />
              {/* Schema.org Organization LD+JSON */}
              <script
                type="application/ld+json"
                dangerouslySetInnerHTML={{
              __html: JSON.stringify({
                "@context": "http://schema.org",
                "@type": "Organization",
                "url": "https://www.autoverwerter-ratingen.de/",
                "logo": "https://www.autoverwerter-ratingen.de/images/logo.png",
                "contactPoint": [{
                  "@type": "ContactPoint",
                  "telephone": process.env.NEXT_PUBLIC_PHONE_NUMBER || "",
                  "email": "info@autoverwerter-ratingen.de",
                  "contactType": "customer service",
                  "contactOption": ["TollFree", "HearingImpairedSupported"],
                  "areaServed": ["DE"],
                  "availableLanguage": ["German"]
                }]
              })
                }}
              />
            </Head>
      <Header />
      <main>
        <ContactActions />
        <Component {...pageProps} />
      </main>

      <Footer />
    </>
  )
}
